module.exports = __webpack_public_path__ + "media/images/new_home/sponsor-logo-2-751ded70861773b2d83c2e90da43f849.png";